import script from "./PasswordChangeDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./PasswordChangeDialog.vue?vue&type=script&setup=true&lang=js"

import "./PasswordChangeDialog.vue?vue&type=style&index=0&id=4a6f2fbb&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4a6f2fbb"]])

export default __exports__